import React from "react";

import styles from "./EmptyStore.module.scss";
import emptyDashboard from "../../../assets/images/empty-dashboard.png";
import {Button} from "../../../components";
import {faSquarePlus} from "@fortawesome/free-solid-svg-icons";
import {Modal} from "../../../components/modal/Modal";
import {StoreLinking} from "./StoreLinking";
import {AXIOS} from "../../../services/api";

function EmptyStore({application, onStoreLinked}) {
    const [isAdding, setIsAdding] = React.useState(false);
    const [error, setError] = React.useState("");

    async function handleLinking({code, store, storeId}) {
        const data = {applicationId: application?.id, code, playStoreId: storeId}
        AXIOS.post(`applications/${application?.id}/stores/google`, data)
            .then(() => {
                onStoreLinked();
                setIsAdding(false);
            })
            .catch((error) => {
                setError("Failed to link store. Please try again.");
            });
    }

    return (
        <div className={styles["empty-store"]}>
            <div className="container-column empty-dashboard">
                <h2>Nothing to Show Yet</h2>
                <p>You have not register.</p>
                <img src={emptyDashboard} alt="Empty Dashboard"/>
                <Button
                    label="Register Store"
                    icon={faSquarePlus}
                    variant="primary"
                    size="xl"
                    onClick={() => setIsAdding(true)}
                />
            </div>

            <Modal show={isAdding}>
                <StoreLinking icon={application.icon}
                              onSubmit={handleLinking}
                              onClose={() => setIsAdding(false)}/>
            </Modal>
        </div>
    );
}

export {EmptyStore};
